<template>
  <div class="main">
    <div class="head-title">
      <div class="left">
        <div @click="$router.back()" class="name">成长册编辑</div>
        <div class="icon">></div>
        <div class="main blue">预览 - {{ studentName }}</div>
      </div>
      <div class="right">
        <div class="num">
          成长册<span class="blue">{{ studentList.length }}</span
          >个
        </div>
        <div class="msg">
          <div class="txt blue">学生信息</div>
          <a-icon
            style="
               {
                color: #898989;
              }
            "
            type="caret-down"
          />
        </div>
      </div>
    </div>
    <div class="content">
      <div class="growup">
        <div class="student-list">
          <div
            @click="changeStudent(item, index)"
            v-for="(item, index) in studentList"
            :key="index"
            :class="currentStudentIndex == index ? 'select' : ''"
            class="cell"
          >
            <img
              :src="
                item.head_img ? item.head_img : require('../assets/icon-11.png')
              "
              alt=""
            />
            <div class="name">{{ item.name }}</div>
          </div>
          <!-- <div v-if="!is_complete" class="submit">
            <div class="left">已经检查完毕确认提交</div>
            <div class="right">
              <a-button @click="handleConfirmSubmit" type="">确认</a-button>
            </div>
          </div> -->
          <div v-if="is_complete" class="submit">
            <div class="left">成长册已确认提交</div>
            <div class="right">
              <a-icon type="check"></a-icon>
              <!-- <a-button @click="handleConfirmSubmit" type="">确认</a-button> -->
            </div>
          </div>
        </div>

        <div ref="plate" class="plate">
          <div
            class="platebox"
            :style="{
              width: 2 * wrapperWidth + 'px',
              height: '750px',
              transform: 'translate(-50%, -50%) scale(' + scaleP + ')',
            }"
          >
            <div
              class="page1"
              ref="page1"
              :style="{ backgroundImage: 'url(' + back1 + ')' }"
            >
              <a-button
                @click="edit1"
                style="position: absolute; right: 0; top: 0; z-index: 1000"
                type="default"
                >编辑</a-button
              >
              <vue-draggable-resizable
                :w="item.width"
                :h="item.height"
                :x="item.left"
                :y="item.top"
                :r="item.rotate"
                :z="item.zIndex"
                :fontFamily="item.fontFamily"
                :textDecoration="item.textDecoration"
                :textIndent="item.textIndent"
                :writingMode="item.writeMode"
                :photoRotate="item.photoRotate"
                :levelType="item.levelType"
                :level="item.level"
                :levelNum="item.levelNum"
                :photoScale="item.photoScale"
                :photoLeft="item.photoLeft"
                :photoTop="item.photoTop"
                :showPhoto="item.showPhoto"
                :shadow="item.shadow ? true : false"
                :allIndex="drags.length - 1"
                :dIndex="index"
                :debug="false"
                :disable="true"
                :lineHeight="item.lineHeight"
                :fontWeight="item.fontWeight"
                :fontStyle="item.fontStyle"
                :textAlign="item.textAlign"
                :type="item.type"
                :isConflictCheck="false"
                :snap="true"
                :snapTolerance="1"
                :lockAspectRatio="item.lockAspectRatio ? true : false"
                :backImg="item.backgroundImg ? item.backgroundImg : ''"
                :bImg2="item.backImg2"
                :bRadius="item.borderRadius"
                :fontColor="item.fColor"
                :text="item.textarea"
                :o="item.opacity"
                dragHandle="false"
                :l="item.lock ? true : false"
                :backColor="item.bColor"
                :borderColor="item.bordersColor"
                :borderLeft="item.bLeft"
                :borderTop="item.bTop"
                :borderRight="item.bRight"
                :borderBottom="item.bBottom"
                :borderStyle="item.bStyle"
                :paddingLeft="item.paddingLeft"
                :paddingTop="item.paddingTop"
                :paddingRight="item.paddingRight"
                :paddingBottom="item.paddingBottom"
                :active="false"
                :fontSize="item.fSize"
                v-for="(item, index) in drags"
                :key="item.ec_id"
              >
                <div v-if="item.type == 3" class="look" style="z-index: -1">
                  <div
                    class="wrap"
                    :style="{
                      width: item.width + 'px',
                      height: item.height + 'px',
                      transform: `scale(${item.width /
                        item.orignWidth},${item.height / item.orignHeight})`,
                      transformOrigin: '0px 0px',
                    }"
                  >
                    <vue-draggable-resizable
                      v-for="(item2, index2) in item.coms"
                      :key="item.ec_id + index2"
                      :w="item2.width"
                      :h="item2.height"
                      :enableNativeDrag="true"
                      :x="item2.left"
                      :y="item2.top"
                      :r="item2.rotate"
                      :z="item2.zIndex"
                      :levelType="item.levelType"
                      :photoScale="item2.photoScale"
                      :photoLeft="item2.photoLeft"
                      :photoTop="item2.photoTop"
                      :showPhoto="item2.showPhoto"
                      :shadow="item2.shadow ? true : false"
                      :dIndex="index"
                      :debug="false"
                      :disable="true"
                      :fontFamily="item.fontFamily"
                      :lineHeight="item2.lineHeight"
                      :fontWeight="item2.fontWeight"
                      :fontStyle="item2.fontStyle"
                      :textAlign="item2.textAlign"
                      :type="item2.type"
                      :isConflictCheck="false"
                      :snap="true"
                      :snapTolerance="1"
                      :lockAspectRatio="item2.lockAspectRatio ? true : false"
                      :backImg="item2.backgroundImg ? item2.backgroundImg : ''"
                      :bImg2="item2.backImg2"
                      :bRadius="item2.borderRadius"
                      :fontColor="item2.fColor"
                      :text="item2.textarea"
                      :o="item2.opacity"
                      :l="item2.lock ? true : false"
                      dragHandle="false"
                      :backColor="item2.bColor"
                      :borderColor="item2.bordersColor"
                      :borderLeft="item2.bLeft"
                      :borderTop="item2.bTop"
                      :borderRight="item2.bRight"
                      :borderBottom="item2.bBottom"
                      :borderStyle="item2.bStyle"
                      :paddingLeft="item2.paddingLeft"
                      :paddingTop="item2.paddingTop"
                      :paddingRight="item2.paddingRight"
                      :paddingBottom="item2.paddingBottom"
                      :active="false"
                      :fontSize="item2.fSize"
                    ></vue-draggable-resizable>
                  </div>
                </div>
              </vue-draggable-resizable>
            </div>
            <div
              class="page2"
              :style="{ backgroundImage: 'url(' + back2 + ')' }"
            >
              <a-button
                @click="edit2"
                style="position: absolute; right: 0; top: 0; z-index: 1000"
                type="default"
                v-if="back2"
                >编辑</a-button
              >
              <vue-draggable-resizable
                :w="item.width"
                :h="item.height"
                :x="item.left"
                :y="item.top"
                :r="item.rotate"
                dragHandle="true"
                :z="item.zIndex"
                :fontFamily="item.fontFamily"
                :photoRotate="item.photoRotate"
                :textDecoration="item.textDecoration"
                :textIndent="item.textIndent"
                :writingMode="item.writeMode"
                :levelType="item.levelType"
                :level="item.level"
                :levelNum="item.levelNum"
                :photoScale="item.photoScale"
                :photoLeft="item.photoLeft"
                :photoTop="item.photoTop"
                :showPhoto="item.showPhoto"
                :shadow="item.shadow ? true : false"
                :allIndex="drags2.length - 1"
                :dIndex="drags.length + index"
                :debug="false"
                :disable="true"
                :lineHeight="item.lineHeight"
                :fontWeight="item.fontWeight"
                :fontStyle="item.fontStyle"
                :textAlign="item.textAlign"
                :type="item.type"
                :isConflictCheck="false"
                :snap="true"
                :snapTolerance="1"
                :lockAspectRatio="item.lockAspectRatio ? true : false"
                :backImg="item.backgroundImg ? item.backgroundImg : ''"
                :bImg2="item.backImg2"
                :bRadius="item.borderRadius"
                :fontColor="item.fColor"
                :text="item.textarea"
                :o="item.opacity"
                :l="item.lock ? true : false"
                :backColor="item.bColor"
                :borderColor="item.bordersColor"
                :borderLeft="item.bLeft"
                :borderTop="item.bTop"
                :borderRight="item.bRight"
                :borderBottom="item.bBottom"
                :borderStyle="item.bStyle"
                :paddingLeft="item.paddingLeft"
                :paddingTop="item.paddingTop"
                :paddingRight="item.paddingRight"
                :paddingBottom="item.paddingBottom"
                :active="item.active ? true : false"
                :fontSize="item.fSize"
                v-for="(item, index) in drags2"
                :key="item.ec_id"
              >
                <div v-if="item.type == 3" class="look" style="z-index: -1">
                  <div
                    class="wrap"
                    :style="{
                      width: item.width + 'px',
                      height: item.height + 'px',
                      transform: `scale(${item.width /
                        item.orignWidth},${item.height / item.orignHeight})`,
                      transformOrigin: '0px 0px',
                    }"
                  >
                    <vue-draggable-resizable
                      v-for="(item2, index2) in item.coms"
                      :key="item.ec_id + index2"
                      :w="item2.width"
                      :h="item2.height"
                      :enableNativeDrag="true"
                      :x="item2.left"
                      :y="item2.top"
                      :r="item2.rotate"
                      :z="item2.zIndex"
                      :fontFamily="item.fontFamily"
                      :photoScale="item2.photoScale"
                      :photoLeft="item2.photoLeft"
                      :photoTop="item2.photoTop"
                      :showPhoto="item2.showPhoto"
                      :shadow="item2.shadow ? true : false"
                      :debug="false"
                      :disable="true"
                      :lineHeight="item2.lineHeight"
                      :fontWeight="item2.fontWeight"
                      :fontStyle="item2.fontStyle"
                      :textAlign="item2.textAlign"
                      :type="item2.type"
                      :isConflictCheck="false"
                      :snap="true"
                      :snapTolerance="1"
                      :lockAspectRatio="item2.lockAspectRatio ? true : false"
                      :backImg="item2.backgroundImg ? item2.backgroundImg : ''"
                      :bImg2="item2.backImg2"
                      :bRadius="item2.borderRadius"
                      :fontColor="item2.fColor"
                      :text="item2.textarea"
                      :o="item2.opacity"
                      :l="item2.lock ? true : false"
                      dragHandle="false"
                      :backColor="item2.bColor"
                      :borderColor="item2.bordersColor"
                      :borderLeft="item2.bLeft"
                      :borderTop="item2.bTop"
                      :borderRight="item2.bRight"
                      :borderBottom="item2.bBottom"
                      :borderStyle="item2.bStyle"
                      :paddingLeft="item2.paddingLeft"
                      :paddingTop="item2.paddingTop"
                      :paddingRight="item2.paddingRight"
                      :paddingBottom="item2.paddingBottom"
                      :active="false"
                      :fontSize="item2.fSize"
                    ></vue-draggable-resizable>
                  </div>
                </div>
              </vue-draggable-resizable>
            </div>
            <div class="cz">
              <a-button v-if="pageinfo1" @click="foword" type="primary">
                <a-icon type="left" />{{
                  pageinfo1.type == 1
                    ? "封面"
                    : pageinfo1.type == 3
                    ? "封底"
                    : "第" + pageinfo1.page_num + "页"
                }}</a-button
              >
              <a-button v-if="pageinfo2" @click="next" type="primary">
                {{
                  pageinfo2.type == 1
                    ? "封面"
                    : pageinfo2.type == 3
                    ? "封底"
                    : "第" + pageinfo2.page_num + "页"
                }}<a-icon type="right"
              /></a-button>
            </div>
          </div>
        </div>
        <a-modal :visible="submitModal" centered :closable="false" footer="">
          <div class="modal3 red">
            <img :src="require('../assets/log2.png')" alt="" />
            <div class="msg">
              <div class="title">已经确认所有成长册修改完毕？</div>
              <div class="btns">
                <a-button @click="submitModal = false">取消</a-button>
                <a-button @click="handleSubmit" type="danger">
                  确认提交
                </a-button>
              </div>
            </div>
          </div>
        </a-modal>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import VueDraggableResizable from "../components/vue-draggable-resizable";
export default {
  data() {
    return {
      studentName: "",
      id: "",
      guc_id: "",
      plateList: [],
      studentList: [],
      wrapperWidth: 500,
      currentPage: 0,
      pages: [],
      drags: [],
      drags2: [],
      back1: "",
      back2: "",
      currentStudentIndex: -1,
      scaleP: 1,
      submitModal: false,
      is_complete: false,
      cover_size: [],
      pageinfo1: null,
      pageinfo2: null,
    };
  },
  components: {
    VueDraggableResizable,
  },
  mounted() {
    this.page1 = this.$refs["page1"].getBoundingClientRect();
    window.onresize = () => {
      if (!this.bAntiShike) {
        this.bAntiShike = true;
        setTimeout(() => {
          this.getScale();
          this.bAntiShike = false;
        }, 800);
      }
    };
  },
  computed: {
    ...mapState(["headers", "userInfo"]),
  },
  created() {
    // this.getPross()
    this.studentName = this.$route.query.name;
    this.id = this.$route.params.id;
    this.guc_id = this.$route.params.guc_id;
    if (this.userInfo) {
      this.getStudent();
      this.getGrowupDetail();
    }
  },
  watch: {
    userInfo(val) {
      if (val) {
        this.getStudent();
        this.getGrowupDetail();
      }
    },
  },

  methods: {
    getPross() {
      this.$axios({
        method: "POST",
        url: 'https://www.guanmini.com/api/progress/index',
        headers: { Authorization: this.$store.state.headers },
        data: {
          limit: 10,
          page: 1,
        },
      })
        .then((res) => {
          console.log(res)
        })
        .catch((res) => {
        });
    },
    handleSubmit() {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.submitGrowup,
        headers: { Authorization: this.$store.state.headers },
        data: {
          gu_id: this.gu_id,
          is_complete: 1,
        },
      })
        .then((res) => {
          this.$message.info(res.data.msg);
          this.submitModal = false;
          if (res.data.status == 200) {
            this.is_complete = true;
          }
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
    handleConfirmSubmit() {
      this.submitModal = true;
    },
    getScale() {
      if (!this.$refs["plate"]) return false
      var plate = this.$refs["plate"].getBoundingClientRect();
      console.log(
        plate.width,
        plate.height,
        this.cover_size[0],
        this.cover_size[1]
      );
      if (
        plate.width / plate.height >
        (this.cover_size[0] * 2) / this.cover_size[1]
      ) {
        this.scaleP = plate.height / (750 + 100);
      } else {
        this.scaleP =
          plate.width /
          (((750 * this.cover_size[0]) / this.cover_size[1]) * 2 + 100);
      }
    },
    edit1() {
      if (this.is_complete) {
        this.$message.error("成长册已提交，不能编辑；如有需要，请联系管理员！");
        return false;
      }
      if (
        this.allPages[this.currentPage * 2].is_lock &&
        this.allPages[this.currentPage * 2].lock_info.teacher_name !=
          this.userInfo.teacher_name
      ) {
        if (this.allPages[this.currentPage * 2].lock_info.is_teacher) {
          this.$notification.open({
            key: "notiy",
            message: "页面锁定",
            description:
              "此页面已被老师" +
              this.allPages[this.currentPage * 2].lock_info.teacher_name +
              "使用，请选择其他页面编辑",
            icon: <a-icon type="close-circle" style="color: #108ee9" />,
          });
        } else {
          this.$notification.open({
            key: "notiy",
            message: "页面锁定",
            description:
              "此页面已被学生" +
              this.allPages[this.currentPage * 2].lock_info.relation +
              "使用，请选择其他页面编辑",
            icon: <a-icon type="close-circle" style="color: #108ee9" />,
          });
        }
        return false;
      }
      localStorage.removeItem("s_id");
      localStorage.removeItem("student_name");
      localStorage.removeItem("page");
      this.$router.push({
        // path: `/mobileEditPlate/${this.id}/${this.guc_id}/${this.userInfo.class_id}`,
        path: `/editplate/${this.id}/${this.guc_id}`,
        query: { name: this.studentName, page: this.currentPage * 2 },
      });
    },
    edit2() {
      if (this.is_complete) {
        this.$message.error('成长册已提交，不能编辑；如有需要，请联系管理员！')
        return false
      }
      if (
        this.allPages[this.currentPage * 2 + 1].is_lock &&
        this.allPages[this.currentPage * 2 + 1].lock_info.teacher_name !=
          this.userInfo.teacher_name
      ) {
        if (this.allPages[this.currentPage * 2 + 1].lock_info.is_teacher) {
          this.$notification.open({
            key: "notiy",
            message: "页面锁定",
            description:
              "此页面已被老师" +
              this.allPages[this.currentPage * 2 + 1].lock_info.teacher_name +
              "使用，请选择其他页面编辑",
            icon: <a-icon type="close-circle" style="color: #108ee9" />,
          });
        } else {
          this.$notification.open({
            key: "notiy",
            message: "页面锁定",
            description:
              "此页面已被学生" +
              this.allPages[this.currentPage * 2 + 1].lock_info.relation +
              "使用，请选择其他页面编辑",
            icon: <a-icon type="close-circle" style="color: #108ee9" />,
          });
        }

        return false;
      }
      this.$router.push({
        // path: `/mobileEditPlate/${this.id}/${this.guc_id}/${this.userInfo.class_id}`,
        path: `/editplate/${this.id}/${this.guc_id}`,
        query: { name: this.studentName, page: this.currentPage * 2 + 1 },
      });
    },
    changeStudent(student, index) {
      this.studentName = student.name;
      this.currentStudentIndex = index;
      this.id = student.id;
      this.currentPage = 0;
      this.drags = [];
      this.drags2 = [];
      this.back1 = "";
      this.back2 = "";
      this.getGrowupDetail();
    },
    foword() {
      if (this.currentPage > 0) {
        this.currentPage--;
        this.getAllGrowupDetail();
      } else {
        this.$message.error("已是第一页");
      }
    },
    next() {
      if (this.pages.length > 2 * this.currentPage + 2) {
        this.currentPage++;
        this.getAllGrowupDetail();
      } else {
        this.$message.error("已到最后一页");
      }
    },
    getStudent() {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.studentList,
        headers: { Authorization: this.$store.state.headers },
      })
        .then((res) => {
          this.studentList = res.data.data.rows;
          this.studentList.forEach((arr, index) => {
            if (arr.name == this.studentName) {
              this.currentStudentIndex = index;
            }
          });
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
    getGrowupDetail() {
      this.$axios({
        method: "GET",
        url: this.$api.domain + this.$api.growupDetail,
        headers: { Authorization: this.headers },
        params: {
          guc_id: this.guc_id,
          s_id: this.id,
        },
      })
        .then((res) => {
          if (res.data.status == 200 && res.data.data) {
            this.pages = res.data.data.page;
            this.getAllGrowupDetail();
          }
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
    getAllGrowupDetail() {
      if (this.pages[2 * this.currentPage]) {
        this.$axios({
          method: "GET",
          url: this.$api.domain + this.$api.growupDetail,
          headers: { Authorization: this.headers },
          params: {
            guc_id: this.pages[2 * this.currentPage].guc_id,
            s_id: this.id,
          },
        })
          .then((res) => {
            if (res.data.status == 200 && res.data.data) {
              this.gu_id = res.data.data.info.gu_id;
              // this.drags = res.data.data.info.content;
              this.pageinfo1 = res.data.data.info;
              this.allPages = res.data.data.page;
              setTimeout(() => {
                this.getAllGrowupDetail();
              }, 180000);
              this.cover_size = res.data.data.info.size.cover_size.split("*");
              this.wrapperWidth =
                (this.cover_size[0] * 750) / this.cover_size[1];
              this.is_complete = res.data.data.info.is_complete ? true : false;
              this.drags = res.data.data.info.content.map((arr) => {
                arr.backgroundImg = arr.backgroundImg
                  ? arr.backgroundImg +
                    "?x-image-process=image/resize,w_650/quality,Q_120"
                  : "";
                // arr.backImg2 +=
                //   "?x-image-process=image/resize,w_650/quality,Q_120";
                arr.textarea = arr.textarea
                  ? arr.textarea.replace(/\\n/g, "<br/>")
                  : "";
                arr.showPhoto = arr.showPhoto
                  ? arr.showPhoto +
                    "?x-image-process=image/resize,w_650/quality,Q_120"
                  : "";
                arr.active = false;
                if (arr.coms) {
                  arr.coms = JSON.parse(arr.coms);
                }
                return arr;
              });
              this.back1 = res.data.data.info.img_bg;
              this.getScale();
            }
          })
          .catch((res) => {
            // this.$message.error(res.data.msg);
          });
      } else {
        this.drags = [];

        this.back1 = "";
      }
      if (this.pages[2 * this.currentPage + 1]) {
        this.$axios({
          method: "GET",
          url: this.$api.domain + this.$api.growupDetail,
          headers: { Authorization: this.headers },
          params: {
            guc_id: this.pages[2 * this.currentPage + 1].guc_id,
            s_id: this.id,
          },
        })
          .then((res) => {
            if (res.data.status == 200 && res.data.data) {
              this.gu_id = res.data.data.info.gu_id;
              this.drags2 = res.data.data.info.content;
              this.pageinfo2 = res.data.data.info;
              this.cover_size = res.data.data.info.size.cover_size.split("*");
              this.wrapperWidth =
                (this.cover_size[0] * 750) / this.cover_size[1];
              this.is_complete = res.data.data.info.is_complete ? true : false;
              this.drags2 = this.drags2.map((arr) => {
                // arr.textarea = decodeURI(arr.textarea);
                arr.textarea = arr.textarea
                  ? arr.textarea.replace(/\\n/g, "<br/>")
                  : "";
                arr.active = false;
                arr.backgroundImg = arr.backgroundImg
                  ? arr.backgroundImg +
                    "?x-image-process=image/resize,w_650/quality,Q_120"
                  : "";
                // arr.backImg2 +=
                //   "?x-image-process=image/resize,w_650/quality,Q_120";
                arr.showPhoto = arr.showPhoto
                  ? arr.showPhoto +
                    "?x-image-process=image/resize,w_650/quality,Q_120"
                  : "";
                if (arr.coms) {
                  arr.coms = JSON.parse(arr.coms);
                }
                console.log(arr.coms);
                return arr;
              });
              this.back2 = res.data.data.info.img_bg;
              this.getScale();
            }
          })
          .catch((res) => {
            // this.$message.error(res.data.msg);
          });
      } else {
        this.drags2 = [];
        this.back2 = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  height: 100%;
}
.content {
  height: 100%;
  padding-bottom: 36px;
}

.growup {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  height: 100%;
  .plate {
    flex: 1 1 0%;
    height: 100%;
    position: relative;
    .platebox {
      border: 1px solid #ccc;
      position: absolute;
      left: 50%;
      top: 49%;
      transform: translate(-50%, -50%);
      display: flex;
      flex-direction: row;
      .cz {
        position: absolute;
        top: 716px;
        width: 100%;
        z-index: 10000;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }
    }
    .page1 {
      -webkit-text-size-adjust: none;
      flex: 1 1 0%;
      position: relative;
      overflow: hidden;
      background-size: 100% 100%;
      border: 1px solid #999;
      &::after {
        position: absolute;
        content: "";
        right: 0;
        width: 1px;
        top: 0;
        bottom: 0;
        background: #ccc;
      }
    }
    .page2 {
      -webkit-text-size-adjust: none;
      flex: 1 1 0%;
      position: relative;
      overflow: hidden;
      background-size: 100% 100%;
      border: 1px solid #999;
    }
  }
  .student-list {
    padding-bottom: 60px;
    width: 285px;
    height: 100%;
    overflow-y: scroll;
    align-items: flex-start;
    justify-content: flex-start;
    margin-top: 10px;
    position: relative;
    box-sizing: border-box;
    padding-bottom: 66px;
    .cell {
      width: 65px;
      text-align: center;
      margin: 0 1px 10px 1px;
      padding: 10px 0;
      float: left;
      &.select {
        background: #dfe7ec;
        border-radius: 4px;
      }
      img {
        width: 42px;
        height: 42px;
        border-radius: 60px;
      }
      .name {
        text-align: center;
        color: #999;
        font-size: 12px;
        margin-top: 10px;
      }
    }
  }
}
.head-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  .left {
    flex: 1 1 0%;
    display: flex;
    flex-direction: row;
    align-items: center;
    .name {
      width: 6.6em;
    }
    .main {
      font-size: 16px;
    }
  }
  .right {
    flex: 1 1 0%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    .msg {
      display: flex;
      flex-direction: row;
      align-items: center;
      .txt {
        margin-right: 3px;
      }
    }
  }
}
.plate-list {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 30px;
  flex-wrap: wrap;
  .cell {
    width: 130px;
    margin-right: 30px;
    margin-bottom: 30px;
    .cover {
      width: 100%;
      height: 168px;
      background-size: contain;
    }
    .name {
      font-size: 14px;
      color: #999;
      text-align: center;
      margin-top: 15px;
    }
  }
}
.submit {
  position: fixed;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  bottom: 0px;
  background: rgb(236, 158, 85);
  left: 225px;
  width: 285px;
  right: 0;
  padding: 10px;
  color: #fff;
  .right {
    margin-right: 12px;
  }
}
</style>
